import { render, staticRenderFns } from "./AccessTokenList.vue?vue&type=template&id=7a2fbf52"
import script from "./AccessTokenList.vue?vue&type=script&lang=js"
export * from "./AccessTokenList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports